<div class="body">

    <div class="headline">
        
        <span class="text">Externe Änderung</span>
        <button mat-icon-button color="warn" (click)="close()">
            <mat-icon>clear</mat-icon>
        </button>

    </div>

    <div>

        Es wurde eine externe Änderung des {{data.typeName? data.typeName: 'Objekt'}}s durch einen anderen Nutzer erkannt.

    </div>

    <ng-container *ngIf="data.externalChange">

        <div *ngIf="data.externalChange.user" class="attribute">
            Nutzer: {{data.externalChange.user}}
        </div>

        <div *ngIf="data.externalChange.date" class="attribute">
            Zeit: {{data.externalChange.date|date:'HH:mm'}} Uhr
        </div>

        <div *ngIf="data.externalChange.message" class="note" [innerHtml]="data.externalChange.message"></div>

    </ng-container>

</div>